import { IWarrantyRepository } from '@/warranty/domain/repositories/warranty.repository';

import {
  BATTERY_LEVELS,
  type BatteryLevel,
  DIM_BY_LEVEL,
} from '../../constants/battery-levels';

export function buildIdFilters(
  assetFullFrontendId: string,
  filters: IWarrantyRepository.Filters,
  level: string | undefined,
): Record<string, string> {
  const queryFilters: Record<string, string> = {
    'frontend_id_mapping.full_frontend_system_id': assetFullFrontendId
      ? assetFullFrontendId
      : '',
    ...(level
      ? {
          'frontend_id_mapping.accure_level':
            level === 'site' ? 'system' : level,
        }
      : { 'frontend_id_mapping.is_unit_level': 'true' }),
  };

  // Map each battery level to its Looker dimension (full frontend ID).
  for (const [key, value] of Object.entries(filters)) {
    if (!value) continue;
    // Match keys like "arrayId", "bankId", etc.
    const match = key.match(/^(.*)Id$/);
    if (!match) continue;
    const level = match[1] as BatteryLevel;
    const field = DIM_BY_LEVEL[level];
    if (field) {
      queryFilters[field] = value;
    }
  }

  return queryFilters;
}

export type AggregationLevel = BatteryLevel | 'site';

// ---- UTILS ----
export function getAggregationLevel(
  filters: IWarrantyRepository.Filters,
  customerId?: string,
  assetId?: string,
): AggregationLevel {
  // Find deepest selected level index
  if (filters.aggregationLevel) {
    return filters.aggregationLevel as AggregationLevel;
  }

  const deepestIdx = BATTERY_LEVELS.reduce((max, lvl, idx) => {
    return filters[`${lvl}Id`] ? idx : max;
  }, -1);

  if (deepestIdx === -1) {
    // nothing selected → aggregate on array level
    if (customerId === '75') {
      return assetId === '26254085168192602' ? 'array' : 'container';
    }
    return 'array';
  }

  const nextIdx = Math.min(deepestIdx + 1, BATTERY_LEVELS.length - 1);
  return BATTERY_LEVELS[nextIdx];
}
